import React from 'react';
import './Loading.css';

export default function Loading() {
  return (
    <div style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      alignItems: 'center',
    }}
    >
      <div className="bernard">
        <div className="📦" />
        <div className="📦" />
        <div className="📦" />
        <div className="📦" />
        <div className="📦" />
      </div>
    </div>
  );
}
